import Vue from 'vue'
import axios from 'axios'
import ErrorMessage from '../../properties/errorMessage'

// const baseURL = 'https://72dxrx0r28.execute-api.ap-northeast-1.amazonaws.com/dev-sx-score'
const baseURL = 'https://api.sx-score.sxi.co.jp'


const Requests = axios.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json',
  withCredentials: false,
  component: new Vue()
})

Requests.interceptors.request.use(request => {
  if (request.url !== '/account' && request.url.search(/s3\.ap-northeast-1\.amazonaws\.com/) === -1) {
    const userName = request.component.$session.get('userName')
    const accessKeyID = request.component.$session.get('accessKeyID')

    request.headers = Object.assign(request.headers || {},
      {'Authorization': `${userName}-${accessKeyID}`})
  }
  return request
})


const defaultErrorHandler = (response, $parent) => {

  const data = response.response.data
  const errorCode = data ? data.error.code : 5002
  const errorArgs = data.error.args

  let displayMessage = ErrorMessage[errorCode]

  if (errorArgs) {
    errorArgs.forEach(value => {
      displayMessage = displayMessage.replace('{}', value)
    })
  }

  $parent.$dialog.alert({
    title: 'エラー',
    message: `${displayMessage}<br>コード：<b>${errorCode}</b><br><br>Email: <b>support-sx-score@sxi.co.jp</b>`,
    type: 'is-danger',
    hasIcon: true
    // icon: 'times-circle',
    // iconPack: 'fa'
  })

  $parent.loading.isActive = false
  $parent.isModalActive = false

  return false
}


export { Requests, defaultErrorHandler }



// WEBPACK FOOTER //
// ./src/modules/request/base.js